import { render, staticRenderFns } from "./list.vue?vue&type=template&id=149b97ac&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=149b97ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149b97ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('149b97ac')) {
      api.createRecord('149b97ac', component.options)
    } else {
      api.reload('149b97ac', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=149b97ac&scoped=true&", function () {
      api.rerender('149b97ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/nc-order/list.vue"
export default component.exports